import WithDirection from '@app/settings/withDirection';
import { Tree } from 'antd';
import AntTree from './styles/tree.style';

const WDTrees = AntTree(Tree);

export const IsoTree = WithDirection(WDTrees);
export const IsoTreeNode = Tree.TreeNode;
